import React from 'react';

export function Loading({ label = 'Loading...' }) {
  return (
    <div className="loading-wrap" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <span className="loading-label">{label}</span>
    </div>
  );
}

export default Loading;
